// extracted by mini-css-extract-plugin
module.exports = {"otpVerify":"PopUpOtp_otpVerify__L9CuS","wrong_otp":"PopUpOtp_wrong_otp__d5jZD","disabled":"PopUpOtp_disabled__Hp47m","confirmButton":"PopUpOtp_confirmButton__Wo_6s"};